export default __webpack_public_path__ + "static/media/service_31.e06f4361.jpg";